import { Create, SimpleForm, useNotify, useRedirect } from "react-admin";
import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router";
import { APPLICATIONS, CAMPAIGNS, SpecialistServicePath } from "utils/constants";

import BackButtonToolbar from "features/BackButtonToolbar";

import InfoForm from "./Create/InfoForm";
import SpecializationsForm from "./Create/SpecializationsForm";
import { useState } from "react";
import GraduationForm from "./Create/GraduationForm";

const CreateCampaignsApplications = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  const location = useLocation();
  const campaignId = location?.state?.campaignId;
  const [isEmployee, setIsEmployee] = useState(true);

  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Create
      resource={`${SpecialistServicePath}${CAMPAIGNS}/${campaignId}/${APPLICATIONS}`}
      title="Създай кандидатура към кампания"
      actions={<BackButtonToolbar />}
      transform={data => {
        if (!data.employeeId) {
          const { employeeId, ...rest } = data;
          return {
            ...rest,
            userInfoCandidate: {
              ...data.userInfoCandidate,
              birthDate: data.userInfoCandidate?.birthDate?.split("T")[0],
            },
            specializationOptions:
              data.specializationOptions?.map(option => ({
                campaignSpecializationOptionId: option.campaignSpecializationOptionId,
                priority: option.priority,
              })) ?? [],
          };
        }
        const { userInfoCandidate, ...rest } = data;
        return rest;
      }}
      mutationOptions={{
        onSuccess: data => {
          redirect(`/${SpecialistServicePath}${APPLICATIONS}`);
        },
        onError: error => {
          console.error(error);

          notify(error.message, { type: "error" });
        },
      }}
    >
      <SimpleForm>
        <InfoForm
          isMobile={isMobile}
          isEmployee={isEmployee}
          setIsEmployee={setIsEmployee}
        />
        <GraduationForm isMobile={isMobile} />
        <SpecializationsForm
          isEmployee={isEmployee}
          setIsEmployee={setIsEmployee}
          isMobile={isMobile}
          campaignId={campaignId}
        />
      </SimpleForm>
    </Create>
  );
};

export default CreateCampaignsApplications;
